import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { map, pluck } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
// Models
import { PD } from '../../models/PD';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';
// Queries
import { UpQuery } from '../../queries/up-analytics.query';
import { setPageTitle } from 'src/app/shared/utilities/utils';
import { CanonicalRoutesService } from 'src/app/shared/services/canonical-routes.service';

@Component({
  selector: 'app-up-analytics',
  templateUrl: './up-analytics.component.html',
  styleUrls: ['./up-analytics.component.scss']
})
export class UpAnalyticsComponent implements OnInit {
  public pageData: PD;

  public pages: Breadcrumbs[];

  private appEnvironment: string;

  constructor(private upquery: UpQuery, private app: AppService, private canonical: CanonicalRoutesService) {
    this.appEnvironment = this.app.configuration['GraphCMS']['environment'];

    this.upquery
      .watch({
        friendlyId: 'up-analytics'
      })
      .valueChanges.pipe(
        pluck('data', 'pDs'),
        map(r => r[0])
      )
      .subscribe((response: PD) => {
        this.pageData = response;

        const titleElement = document.querySelector('title');
        setPageTitle(titleElement, this.pageData.nombre);

        this.pages = [
          { page: 'Afiliados', route: '/afiliados', isActive: false },
          { page: this.pageData.nombre, isActive: true }
        ];
      });
  }

  ngOnInit(): void {
    this.canonical.setCanonicalRoute();
  }
}
